import React, { FC, useEffect } from 'react';
import { Button, Alert } from 'reactstrap';
import Popup from 'src/components/content/popup/popup';
import ContentWrapper from 'src/components/content/content-wrapper';
import ContentSection from 'src/components/content/content-section';
import warning from '../../../../../assets/icons/warning.svg';
import styles from './update-subscription.module.scss';
import { trackReactivationViewed } from 'src/util/track';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  isReactivating: boolean;
  reactivateError: string;
  onConfirm: () => Promise<void>;
}

export const ReactivateSubscriptionPopup: FC<Props> = ({
  isOpen,
  onClose,
  isReactivating,
  reactivateError,
  onConfirm,
}) => {
  useEffect(() => {
    if (isOpen) {
      trackReactivationViewed('update_subscription');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <Popup>
      <ContentWrapper className={styles.background} collapseAt="sm">
        <ContentSection
          className={styles.updateSubscriptionWarning}
          collapseAt="sm">
          <Button
            className={styles.close}
            onClick={onClose}
            disabled={isReactivating}
          />
          <div style={{ textAlign: 'center', marginBottom: '15px' }}>
            <img src={warning} alt={''} />
          </div>
          <div className={styles.title}>Reactivate subscription</div>
          <div className={styles.bodytext} style={{ textAlign: 'center' }}>
            Are you sure you want to reactivate your subscription? This will
            cancel your pending cancellation and resume your current billing
            cycle.
          </div>
          {reactivateError && (
            <Alert color="danger" style={{ marginBottom: '15px' }}>
              {reactivateError}
            </Alert>
          )}
          <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
            <Button
              outline
              style={{ flex: 1 }}
              onClick={onClose}
              disabled={isReactivating}>
              Cancel
            </Button>
            <Button
              style={{ flex: 1 }}
              onClick={onConfirm}
              disabled={isReactivating}>
              {isReactivating ? 'Reactivating...' : 'Confirm'}
            </Button>
          </div>
        </ContentSection>
      </ContentWrapper>
    </Popup>
  );
};
